/**
 * Build a cache-busted `<img src>` for a tenant logo.
 *
 * Logo storage is overwrite-no-versioning (the key is always
 * `tenants/{id}/logo.png`), so a re-upload doesn't change `logo_url` — the
 * browser and CDN would keep serving the old image until their cache expires.
 * Appending the tenant's `logo_updated_at` as a `?v=` param gives each logo
 * version a distinct URL, so a fresh upload repaints immediately and a reload
 * still resolves to the right image.
 *
 * The Naya default logo is shared and effectively immutable, so it's returned
 * untouched — no bust param, lets it stay cached.
 */
export function logoSrc(
  logoUrl: string | null,
  defaultLogoUrl: string,
  logoUpdatedAt: string,
): string {
  if (!logoUrl) return defaultLogoUrl
  const sep = logoUrl.includes('?') ? '&' : '?'
  return `${logoUrl}${sep}v=${encodeURIComponent(logoUpdatedAt)}`
}
